export { AffiliatedCompaniesTable } from './AffiliatedCompaniesTable'
